/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    CommentCreate,
    CommentCreateFromJSON,
    CommentCreateToJSON,
    CommentCreateAdminAllOf,
    CommentCreateAdminAllOfFromJSON,
    CommentCreateAdminAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface CommentCreateAdmin
 */
export interface CommentCreateAdmin {
    /**
     * 
     * @type {string}
     * @memberof CommentCreateAdmin
     */
    parentCommentId?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentCreateAdmin
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof CommentCreateAdmin
     */
    mergedPostId?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentCreateAdmin
     */
    authorUserId: string;
}

export function CommentCreateAdminFromJSON(json: any): CommentCreateAdmin {
    return {
        'parentCommentId': !exists(json, 'parentCommentId') ? undefined : json['parentCommentId'],
        'content': json['content'],
        'mergedPostId': !exists(json, 'mergedPostId') ? undefined : json['mergedPostId'],
        'authorUserId': json['authorUserId'],
    };
}

export function CommentCreateAdminToJSON(value?: CommentCreateAdmin): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'parentCommentId': value.parentCommentId,
        'content': value.content,
        'mergedPostId': value.mergedPostId,
        'authorUserId': value.authorUserId,
    };
}


